import * as actions from "./date-range.action";

export const getDefaultDateRange = () => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const startDate = new Date(today);
  startDate.setDate(today.getDate() - 30);
  startDate.setHours(0, 0, 0, 0);

  return {
    startDate,
    endDate: today,
    preset: "last_30_days"
  };
};

export const createDateRangeReducer = scope => (
  state = getDefaultDateRange(),
  action
) => {
  if (action.meta?.scope !== scope) {
    return state;
  }

  switch (action.type) {
    case actions.SET_DATE_RANGE:
    case actions.SET_DATE_RANGE_PRESET:
      return {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        preset: action.payload.preset
      };
    default:
      return state;
  }
};

export const auditLogsDateRangeReducer = createDateRangeReducer(
  actions.DATE_RANGE_SCOPES.AUDIT_LOGS
);
